import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import dayjs from 'dayjs';

import { Job, OutletContext } from '@typings';

import { JobDetailsContent, JobDetailsItem } from '@components/Job';
import {
  PlatformAppLogo,
  PlatformAppManagementParamsSection,
} from '@components/Ui/PlatformApps';

export const PlatformAppsInstanceOverviewPage = () => {
  const { instance, input, output, setTabTitle } =
    useOutletContext<OutletContext.PlatformAppsInstance>();

  const {
    id,
    name,
    creator,
    state,
    appType,
    createdAt,
    displayName,
    namespace,
    orgName,
    projectName,
    templateName,
    templateVersion,
  } = instance;

  useEffect(() => {
    setTabTitle(Job.Tab.Overview);
  }, [setTabTitle]);

  return (
    <JobDetailsContent>
      <div className="flex gap-10">
        <div className="flex gap-4">
          <PlatformAppLogo size="sm" />
          <div className="flex flex-col gap-1.5">
            <p className="text-headline">{templateName}</p>
            <p className="text-body-medium">Version: {templateVersion}</p>
          </div>
        </div>
        <div className="flex flex-col gap-1.5">
          <p className="text-footnote capitalize text-neural-04">
            Installation date
          </p>
          <p className="text-rebecca">{dayjs(createdAt).format('L LT')}</p>
        </div>
        <div className="flex flex-col gap-1.5">
          <p className="text-footnote capitalize text-neural-04">Owner</p>
          <p className="text-rebecca">{creator}</p>
        </div>
      </div>
      <JobDetailsItem copy title="ID" text={id} />
      <JobDetailsItem copy title="Name" text={name} />
      <JobDetailsItem copy title="Display Name" text={displayName} />
      <JobDetailsItem title="Type" text={appType} />
      <JobDetailsItem title="Status" text={state} />
      <JobDetailsItem title="Project" text={projectName} />
      <JobDetailsItem title="Organization" text={orgName} />
      <JobDetailsItem title="Namespace" text={namespace} />

      <PlatformAppManagementParamsSection
        type="input"
        templateVersion={templateVersion}
        templateName={templateName}
        params={input}
      />
      <PlatformAppManagementParamsSection
        type="output"
        templateVersion={templateVersion}
        templateName={templateName}
        params={output}
      />
    </JobDetailsContent>
  );
};
